export const SET_CHANGES = "SET_CHANGES";
export const SET_FINE_GRANULARITY_CHANGES = "SET_FINE_GRANULARITY_CHANGES";
export const RESET_CHANGES = "RESET_CHANGES";
